import React from 'react';
import { FiSearch, FiUpload } from 'react-icons/fi';

export const Input = ({
  id,
  type = 'text',
  name,
  label,
  required = false,
  value,
  onChange,
  onBlur,
  size = 'sm',
  error = false,
  variant = '',
  className = '',
}) => {
  const sizeClasses = {
    xs: 'px-2 pt-3 pb-0.5 text-base w-[22vw]',
    sm: 'px-3 pt-3 pb-1 text-base',
    md: 'px-3 h-[3.2rem] text-base',
    lg: 'px-4 pt-6 pb-3 text-base',
  };

  const labelTopClasses = {
    xs: 'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-focus:top-[-0.4rem] peer-focus:translate-y-0',
    sm: 'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-focus:top-[-0.4rem] peer-focus:translate-y-0',
    md: 'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-focus:top-[-0.5rem] peer-focus:translate-y-0',
    lg: 'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-focus:top-[-0.6rem] peer-focus:translate-y-0',
  };

  const isFixedLabel = !!value || type === 'date' || type === 'file';
  const forceTop = isFixedLabel ? '!top-[-0.5rem] !translate-y-0' : '';

  const isSearch = variant === 'search';
  const isFile = type === 'file';

  return (
    <div className={`relative ${isSearch ? 'mb-0 w-full sm:w-[20rem]' : 'mb-5 w-full'}`}>
      
      {!isFile && (
        <>
          <input
            id={id}
            type={type}
            name={name || id}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            required={required}
            placeholder=" "
            className={`
              peer block w-full appearance-none 
              rounded-tl-2xl rounded-tr-2xl rounded-br-2xl
              focus:outline-none focus:ring-1
              transition-all border pr-10
              ${error
                ? 'border-red-500 focus:ring-red-200 focus:border-red-600'
                : 'border-gray-300 focus:ring-purple-500/25 focus:border-purple-700'}
              ${isSearch ? 'h-9 px-3 text-sm' : sizeClasses[size]} 
              ${className}
            `}
          />

          {label && (
            <label
              htmlFor={id}
              className={`
                absolute left-4 bg-white px-1 transition-all pointer-events-none
                text-sm
                ${error ? 'text-red-500 peer-focus:text-red-600' : 'text-gray-500 peer-focus:text-purple-700'}
                ${isSearch ? labelTopClasses['xs'] : labelTopClasses[size]} 
                ${forceTop}
              `}
            >
              {required && '*\u00A0'}
              {label}
            </label>
          )}

          {isSearch && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">
              <FiSearch size={16}/>
            </div>
          )}
        </>
      )}

      {isFile && (
        <>
          {label && (
            <label
              htmlFor={id}
              className={`
                absolute -top-2 left-4 bg-white px-1
                text-sm transition-all
                ${error ? 'text-red-500' : 'text-gray-500'}
              `}
            >
              {required && '*\u00A0'}
              {label}
            </label>
          )}

          <label
            htmlFor={id}
            className={`
              flex items-center gap-2 border rounded-tl-2xl rounded-tr-2xl rounded-br-2xl cursor-pointer h-[2.625rem] px-3 text-sm
              transition hover:border-purple-500 text-gray-500
              ${error ? 'border-red-500' : 'border-gray-300'}
            `}
          >
            <FiUpload size={16} />
            <span>
              {value && value.name
                ? value.name
                : 'Suba Arquivo'}
            </span>
            <input
              id={id}
              type="file"
              name={name || id}
              onChange={(e) => onChange(e, name || id)}
              onBlur={onBlur}
              required={required}
              className="hidden"
            />
          </label>
        </>
      )}
    </div>
  );
};

export default Input;
